import { render, staticRenderFns } from "./suppliers-new.vue?vue&type=template&id=40224558&scoped=true"
import script from "./suppliers-new.vue?vue&type=script&lang=js"
export * from "./suppliers-new.vue?vue&type=script&lang=js"
import style0 from "./suppliers-new.vue?vue&type=style&index=0&id=40224558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40224558",
  null
  
)

export default component.exports